import SleepioResources from './SleepioResources';

export default SleepioResources;
